module.exports = __webpack_public_path__ + "img/LG_ct-silhouette.c51e5ff0.png";